"use client";

import { cn } from "@/lib/cn";
import { useAuth, useSdkConfig, useUser } from "@/provider";

import { AuthButton } from "./AuthButton";
import { UserMenu } from "./UserMenu";

export interface HeaderAuthProps {
  profileLink?: string;
  profileLectorLink?: string;
}

export const HeaderAuth = ({
  profileLink,
  profileLectorLink,
}: HeaderAuthProps) => {
  const { isAuthorized } = useAuth();
  const { user, isLoading } = useUser();
  const config = useSdkConfig();
  const isDarkHeader = config.theme === "dark";

  if (!isAuthorized) {
    return <AuthButton />;
  }

  if (isLoading) {
    return (
      <div
        className={cn(
          "sdkui:inline-flex sdkui:h-10 sdkui:w-10 sdkui:animate-pulse sdkui:items-center sdkui:justify-center sdkui:rounded-full sdkui:lg:w-28",
          isDarkHeader ? "sdkui:bg-dark-80" : "sdkui:bg-zinc-100"
        )}
      >
        <span
          className={cn(
            "sdkui:hidden sdkui:text-sm sdkui:lg:inline",
            isDarkHeader ? "sdkui:text-white" : "sdkui:text-dark-40"
          )}
        >
          Загрузка
        </span>
      </div>
    );
  }

  if (!user) {
    return <AuthButton />;
  }

  return (
    <UserMenu profileLectorLink={profileLectorLink} profileLink={profileLink} />
  );
};
